import { makeActionCreator } from '../../config/store/utils'

export const SHOW_CONTINGENCIES_INFORMATION_DIALOG = 'SHOW_CONTINGENCIES_INFORMATION_DIALOG'
export const onShowContingenciesInformationDialog = makeActionCreator(SHOW_CONTINGENCIES_INFORMATION_DIALOG, 'payload')
